import { Navigate, useSearchParams } from 'react-router';

/** Legacy settings tab URL — preserve checkout return query params. */
export const SubscriptionsLegacyRedirect = () => {
  const [searchParams] = useSearchParams();
  const hasCheckoutParams =
    searchParams.get('checkout') != null || searchParams.get('sessionId') != null;
  const target = hasCheckoutParams
    ? `/subscriptions?${searchParams.toString()}`
    : '/subscriptions?adjust=1';

  return <Navigate to={target} replace />;
};
